import { render, staticRenderFns } from "./color.vue?vue&type=template&id=77dec09d&scoped=true"
import script from "./color.vue?vue&type=script&lang=js"
export * from "./color.vue?vue&type=script&lang=js"
import style0 from "./color.vue?vue&type=style&index=0&id=77dec09d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dec09d",
  null
  
)

export default component.exports